import { gql } from '@apollo/client';

/** Read from the cache only; the POS menu query has already loaded every variation */
export const VARIATION_NAME_FRAGMENT = gql`
  fragment QrPayLaterVariationName on Variation {
    id
    name
    nameLang {
      id
      se
      en
      es
      no
    }
  }
`;
